<template>
  <van-tabbar v-model="currentActive" :border="false">
    <van-tabbar-item v-for="(item, index) in tabbarList" :key="index" :name="item.path" @click="tabbarGo(item.path)">
      <span>{{ $t(item.textKey) }}</span>
      <template #icon="props"> <img :src="props.active ? item.inactive : item.active" /> </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
export default {
  name: 'tabbar',
  data() {
    return {
      currentActive: this.actives,
    }
  },
  watch: {
    actives(value) {
      this.currentActive = value
    },
  },
  computed: {
    tabbarList() {
      return [
        {
          textKey: 'app.news',
          path: '/notice',
          active: require('@/assets/tab/tab-icon2.png'),
          inactive: require('@/assets/tab/tab-icon2-s.png'),
        },
        {
          textKey: 'app.Home',
          path: '/home',
          active: require('@/assets/tab/tab-icon1.png'),
          inactive: require('@/assets/tab/tab-icon1-s.png'),
        },
        {
          textKey: 'route.polymarket',
          path: '/polymarket',
          active: require('@/assets/tab/tab-icon4.png'),
          inactive: require('@/assets/tab/tab-icon4-s.png'),
        },
        {
          textKey: 'tabbar.predict',
          path: '/tab_tran',
          active: require('@/assets/tab/tab-icon3.png'),
          inactive: require('@/assets/tab/tab-icon3-s.png'),
        },
        {
          textKey: 'app.Accounts',
          path: '/assets',
          active: require('@/assets/tab/tab-icon5.png'),
          inactive: require('@/assets/tab/tab-icon5-s.png'),
        },
      ]
    },
  },
  props: {
    actives: {
      type: String,
      default: '/home',
    },
  },
  methods: {
    tabbarGo(item) {
      // if (item === '/tab_tran') {
      //   this.$router.push(item)
      //   return
      // }
      this.$router.replace(item)
    },
  },
}
</script>

<style lang="scss" scoped>
.van-tabbar {
  height: 60px !important;
  background: #ffffff !important;
  overflow: hidden;
  width: 100%;
  border-top: 1px solid #e3e3e3;

  .van-tabbar-item--active {
    color: #8bc318 !important;
    font-weight: 600;
  }
}

.van-tabbar-item__icon img {
  height: 20px !important;
  width: 20px !important;
  padding: 5px 0 3px;
}

::v-deep .van-tabbar-item__text {}
</style>
